module.exports = __webpack_public_path__ + "static/media/Group 73 (1).cfb8ee01.png";